import { FETCH_XBK_CONFIG } from '../constants';
import { XBK_DOWNLOAD_LINK } from '../config'

import creator from './creator';

export const xbkConfigFetch = creator(FETCH_XBK_CONFIG, 'download');

export function xbkVersion() {
  return async function fetchXbkVersion(dispatch, getState, { ds }) {
    try {
      const resp = await ds.xbkVersion()
      const data = await resp.json();
      if (data.latest && data.latest.version && data[data.latest.version]) {
        const versionInfo = data[data.latest.version]
        dispatch(xbkConfigFetch(`${versionInfo.download}${versionInfo.packageName}`))
      } else {
        dispatch(xbkConfigFetch(XBK_DOWNLOAD_LINK))
      }
    } catch (err) {
      dispatch(xbkConfigFetch(XBK_DOWNLOAD_LINK))
      console.error('获取小班课下载链接失败', err) // eslint-disable-line no-console
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/download.js